<div class="sec-title">
    <h1>Liste des soustraitants</h1>
</div>
<div class="col-6 col-md-6 d-flex justify-content-end">
  <a class="btn btn-success" routerLink="../soustraitant/ajouter" role="button"><i class="bi bi-plus-circle"></i> Ajouter un sous traitant</a>
</div>
<div><a class="btn btn-action" href="/gestion" routerLink="/gestion" role="button"><i class="bi bi-arrow-90deg-left"></i> retour à gestion</a></div>
<ul class="list-inline">
    <li *ngFor="let contractor of contractorsList; let i = index;">
      <div class="card col-lg-6 col-md-12 me-3 mt-3">
            <div class="card-body">
              <h5 class="card-title">{{contractor.company_name}}</h5>
              <h6 class="card-subtitle mb-2 text-muted">{{contractor.contact_name}}</h6>
              <a routerLink="../soustraitant/{{contractor.contractor_id}}/editer" class="btn btn-primary">Editer</a>
            </div>
        </div>
    </li>
</ul>